import { createSlice } from "@reduxjs/toolkit";
import { getDealList } from "../../reduxApi/admin/DealReduxApi";

const dealSlice = createSlice({
    name: 'deal',
    initialState: {
        status: 'idel',
        isFiltered: false,
        deal: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteDealAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.deal.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.deal.splice(index, 1);
                }
            });
        },
        updateDealAction: (state, action) => {
            const index = state.deal.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.deal.splice(index, 1, { deals: action.payload })
            }
        },
        addDealAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.deal.unshift({ deals: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDealList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getDealList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.deal = action.payload.data.deals;
            })
    }
})
export const { deleteDealAction, updateDealAction, addDealAction, setFilteredStatus } = dealSlice.actions
export default dealSlice.reducer